import { events, CoreEvents } from 'coreEventsOLD';
import { OPEN_MODAL, CREATE_ACCOUNT } from './types';
import { DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER } from '../../../constants/modalNames';

export const openModal = (modalName, headerContextAccountModal) => {
  if (modalName === 'ACCOUNT_MODAL') {
    CoreEvents.emit(events.accountModal.open, {
      ...headerContextAccountModal,
    });

    return {
      type: 'NEW_ACCOUNT_MODAL',
    };
  }

  return {
    type: OPEN_MODAL,
    modalName,
  };
};

export const createAccount = (detail = {}) => ({
  type: CREATE_ACCOUNT,
  callerIdentifier: detail?.callerIdentifier ?? DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER,
  modalTitle: detail?.modalTitle ?? null,
  onSuccess: detail?.onSuccess ?? null,
  onError: detail?.onError ?? null
});
